<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type" 

    
  >
    <!-- {{JSON.stringify(context)}} -->
    <table width="100%" :class="`formulate-input-element-${context.type} table b-table table-striped table-hover`">
      <thead>
        <tr>
          <th v-for="header,c in context.attributes.columns" :key="header" >
            <label-editable :resourcekey="context.name+'_col'+c" :text="header " />
          </th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="(option, index) in options" :key="option.value" >
          <td class="text-center" v-if="context.attributes.displayIndex"> {{index+1}}</td>
          <td class="text-center" v-for="(header) in option.prefixValues" :key="header" >
            <span v-if="header==='☑'" style="color:red;font-size:18px;font-weight:bold;">{{header}}</span>
            <span v-if="header!=='☑'">{{header}}</span>
          </td>
          <td> <input
                type="checkbox"
                :id="context.name+'-'+index"
                :name="context.name"
                :value="option.value"
                :checked="modelHasValue(option.value)"
                @input="(evt)=>check(option.value, evt.target.checked)"
                class="formulate-input-element"
                  />

          </td>
          <td><div class="formulate-input-wrapper">
              <label class="formulate-input-label"          v-if="!isEditMode()" :for="context.name+'-'+index">{{R(option.value, option.label)}}</label>
              <label-editable class="formulate-input-label" v-if="isEditMode()" :for="context.name+'-'+index" :resourcekey="option.value" :text="option.label"></label-editable>
              </div>
          </td>
          <td v-for="(header, i) in option.suffixValues" :key="header" >
            <label class="formulate-input"          v-if="!isEditMode()" :for="context.name+'-'+index">{{R(option.value+'_'+i, header)}}</label>
            <label-editable class="formulate-input" v-if="isEditMode()"  :resourcekey="option.value+'_'+i" :text="header"></label-editable>
          </td>
      </tr>
      </tbody>
    </table>

  </div>

</template>

<script>
import ppeBusiness from 'ppe-business'
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  methods : {
    modelHasValue(v) {
      //console.log('CheckboxTable:modelHasValue', v)
      return this.context.model.includes(v)
    },
    R(resourcekey, defaultValue) {
      return ppeBusiness.R(resourcekey, defaultValue)
    },
    isEditMode() {
      return this.$features.labelEditMode
    },
    check(value, checked) {
      if( !Array.isArray(this.context.model) ) this.context.model = []
      if(checked) {
        if(!this.context.model.includes(value))
          this.context.model.push(value)
      } else {
        var index = this.context.model.indexOf(value);
        if (index !== -1) {
          this.context.model.splice(index, 1);
        }
      }
      console.log("CheckboxTable:check", this.context.model)
    },
  },
  computed: {
    model () {
      //console.log("CheckboxTable:this.model", this.context.model)
      return this.context.model
    },
    options () {
      return this.context.options
    }
  }

}
</script>